// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"90beb5ec","178":"f7913390","369":"c4748c12","447":"bec2b4e1","532":"7617896b","685":"fc254f5d","787":"fb3ba03c","882":"e25d5782","975":"2f56d5cc"}[chunkId] + ".chunk.js";
};